export const GET_PROMPT_TAGS = "GET_PROMPT_TAGS";
export const ADD_PROMPT_TAG = "ADD_PROMPT_TAG";

export const GET_PROMPTS = "GET_PROMPTS";
export const ADD_PROMPT = "ADD_PROMPT";
export const UPDATE_PROMPT = "UPDATE_PROMPT";
export const DELETE_PROMPT = "DELETE_PROMPT";

export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR"; 